<template>
  <span class="activity-symbol" :style="symbolStyle" aria-hidden="true">
    <img v-if="imageVisible" :src="visual.img" alt="" loading="lazy" @error="failedImage = visual.img" />
    <v-icon v-else :size="size * .53">{{ activity.icon || 'mdi-motion-play-outline' }}</v-icon>
  </span>
</template>
<script>
import { activitySplitVisual } from "@/services/customerHubActivityVisual"
export default {
  props: { activity: { type: Object, required: true }, size: { type: Number, default: 44 } },
  data: () => ({ failedImage: "" }),
  computed: {
    visual() { return activitySplitVisual(this.activity) },
    imageVisible() { return this.visual && this.visual.img !== this.failedImage },
    symbolStyle() { return { width: this.size + "px", height: this.size + "px", backgroundColor: this.imageVisible ? this.visual.color : null } },
  },
}
</script>
<style scoped>
.activity-symbol { display: inline-grid; place-items: center; flex: 0 0 auto; border-radius: 13px; background: #ffffff06; overflow: hidden; }
.activity-symbol img { display: block; width: 80%; height: 80%; object-fit: contain; }
.activity-symbol .v-icon { color: #c4ceca; }
</style>
